export function Header() {
  return (
    <div className="flex px-8 flex-row items-center justify-between text-xs widthFull text-gray-800">
      <div className="flex gap-4 items-center justify-center">
        <p className="text-lg">Asset Finance</p>
      </div>
      <div className="flex gap-4 relative rounded-md items-center bg-black text-white px-8 py-2">
        <p className="">Caseworker</p>
      </div>
    </div>
  );
}
